module.exports = __webpack_public_path__ + "static/media/header.7a43ee2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Collaborators/img/header.jpg
// module id = 384
// module chunks = 0